import Network from '@/common/lib/Network';
import Store from '@/config/store';

export default {

  /**
   * Génère un bon de livraison sur le serveur 
   * et retourne le chemin dans une Promise
   *
   * @param   {integer}  pnbl  Numéro du bon de livraison
   *
   * @return  {Promise}
   */
  getDownloadBL(pnbl) {

    let params = {
      piduser: Store.getters['application/get_application_user'].id,
      pcsoc: Store.getters['application/get_application_company'].PCSOC,
      pnbl
    };

    return Network.execute('GET', 'CWEBS0060A', params, {}, {
      'Content-Type': 'application/json',
      'Accept': 'application/pdf'
    }, 'arraybuffer');
  },
  /**
   * Génère la liste de colosiage sur le serveur 
   * et retourne le chemin dans une Promise
   *
   * @param   {integer}  pliste  Numero de liste
   *
   * @return  {Promise}
   */
  getDownloadPackingList(pliste) {
      
    let params = {
      piduser: Store.getters['application/get_application_user'].id,
      pcsoc: Store.getters['application/get_application_company'].PCSOC,
      pnocl: Store.getters['application/get_application_customer'].TNCLI,
      pliste
    };

    return Network.execute('GET', 'CWEBS0062A', params, {}, {
      'Content-Type': 'application/json',
      'Accept': 'application/pdf'
    }, 'arraybuffer');
  },
  /**
   * Récupère les bons de livraison en fonction des 
   * critères de recherche passé dans l'objet <query_data>
   *
   * @param   {[type]}  query_data  Objet de recherche des bons de livraison
   *
   * @return  {[type]}              [return description]
   */
  getDeliveryForm(query_data) {

    let data = {
      piduser: Store.getters['application/get_application_user'].id,
      pcsoc: Store.getters['application/get_application_company'].PCSOC,
      pnocl: Store.getters['application/get_application_customer'].TNCLI,
      ...query_data
    };

    return Network.execute('GET', 'CWEBS0036A', data);
  },
  /**
   * Affiche la liste des produits associé au bon de livraison
   * passé en paramètre
   *
   * @param   {integer}  pnbl  Numéro du bon de livraison
   *
   * @return  {Promise}
   */
  getProduct(pnbl) {

    let data = {
      piduser: Store.getters['application/get_application_user'].id,
      pcsoc: Store.getters['application/get_application_company'].PCSOC,
      pnocl: Store.getters['application/get_application_customer'].TNCLI,
      pnbl
    };

    return Network.execute('GET', 'CWEBS0038A', data);
  },
  /**
   * Affiche la liste des coloris associé au bon de livraison
   * passé en paramètre
   *
   * @param   {integer}  pnbl   Numéro du bon de livraison
   *
   * @return  {Promise}
   */
  getColor(pnbl) {

    let data = {
      piduser: Store.getters['application/get_application_user'].id,
      pcsoc: Store.getters['application/get_application_company'].PCSOC,
      pnocl: Store.getters['application/get_application_customer'].TNCLI,
      pnbl
    };

    return Network.execute('GET', 'CWEBS0039A', data);
  },
  /**
   * Affiche la liste des tailles associé au bon de livraison
   * passé en paramètre
   *
   * @param   {integer}  pnbl   Numéro du bon de livraison
   *
   * @return  {Promise}
   */
  getSize(pnbl) {
    
    let data = {
      piduser: Store.getters['application/get_application_user'].id,
      pcsoc: Store.getters['application/get_application_company'].PCSOC,
      pnocl: Store.getters['application/get_application_customer'].TNCLI,
      pnbl
    };

    return Network.execute('GET', 'CWEBS0040A', data);
  },
  /**
   * Affiche la liste des références commande client
   * associé au bon de livraison passé en paramètre
   *
   * @param   {integer}  pnbl   Numéro du bon de livraison
   *
   * @return  {Promise}
   */
  getReference(pnbl) {

    let data = {
      piduser: Store.getters['application/get_application_user'].id,
      pcsoc: Store.getters['application/get_application_company'].PCSOC,
      pnocl: Store.getters['application/get_application_customer'].TNCLI,
      pnbl
    };

    return Network.execute('GET', 'CWEBS0041A', data);
  },
  getDeliveryFormDetails(query_data) {

    let data = {
      piduser: Store.getters['application/get_application_user'].id,
      pcsoc: Store.getters['application/get_application_company'].PCSOC,
      pnocl: Store.getters['application/get_application_customer'].TNCLI,
      ...query_data
    };

    return Network.execute('GET', 'CWEBS0037A', data);
  },
  /**
   * Récupère le détail du bon de livraison passé en paramètre
   *
   * @param   {integer}  pnbl   Numéro du bon de livraison
   *
   * @return  {Promise}
   */
  getDeliveryFormDetailsInfo(pnbl) {

    let data = {
      piduser: Store.getters['application/get_application_user'].id,
      pcsoc: Store.getters['application/get_application_company'].PCSOC,
      pnocl: Store.getters['application/get_application_customer'].TNCLI,
      pnbl
    };

    return Network.execute('GET', 'CWEBS0042A', data);
  },
}